import React from 'react'

const QuickContact = () => (
  <div className="quick__inner">
    <p className="quick__link">t: <a href="tel:+19543899960" >+1 954 389 9960</a></p>
    <p className="quick__link">m: <a href="mailto:hello@mwxdigital.com">hello@mwxdigital.com</a></p>
  </div>
)

export default QuickContact;